import React from "react";
import { ArrowUpRight, MapPin } from "lucide-react";
import { CONTACT, HARDWARE, HARDWARE_TECH } from "../../data/content";
import { Reveal, SectionHeading } from "../ui";

const READER_IMG = "https://kntopass.blob.core.windows.net/websit-assets/1750369419953.jpg";

const Hardware = () => (
  <section id="hardware" className="section bg-ink-900/40">
    <div className="container">
      <SectionHeading
        eyebrow="Hardware"
        title="Readers designed and manufactured in Egypt."
        subtitle="Our own QR and NFC hardware, built in-house for faster customization, reliable supply and regional support."
      />

      <div className="mt-16 grid gap-6 lg:grid-cols-12">
        <Reveal className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-ink-900 lg:col-span-5">
          <img
            src={READER_IMG}
            alt="T-PRO KNTO Pass reader installed at an entrance"
            loading="lazy"
            className="h-full min-h-[22rem] w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/30 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-8">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-white backdrop-blur">
              <MapPin className="h-3.5 w-3.5 text-brand-400" /> Made in Egypt
            </span>
            <p className="mt-4 font-display text-2xl font-semibold text-white">
              Hardware and software from one team, so every gate just works.
            </p>
          </div>
        </Reveal>

        <div className="grid gap-4 sm:grid-cols-2 lg:col-span-7">
          {HARDWARE.map((d, i) => (
            <Reveal key={d.name} delay={i * 80} className="card card-hover flex flex-col p-7">
              <div className="flex items-center justify-between">
                <h3 className="font-display text-2xl font-semibold tracking-tight text-white">{d.name}</h3>
                <span className="rounded-full border border-brand-600/30 bg-brand-600/10 px-2.5 py-0.5 text-xs font-medium text-brand-300">
                  {d.tag}
                </span>
              </div>
              <p className="mt-3 flex-1 leading-relaxed text-ink-400">{d.desc}</p>
            </Reveal>
          ))}

          <Reveal className="card p-7 sm:col-span-2">
            <p className="text-xs font-medium uppercase tracking-[0.18em] text-ink-400">Built-in technologies</p>
            <ul className="mt-4 flex flex-wrap gap-2">
              {HARDWARE_TECH.map((t) => (
                <li key={t} className="rounded-full bg-white/5 px-3 py-1.5 text-sm text-ink-200 ring-1 ring-inset ring-white/10">
                  {t}
                </li>
              ))}
            </ul>
            <a
              href={`${CONTACT.kntoUrl}content/details/t-pro-knto-reader`}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-400 hover:text-brand-300"
            >
              View reader specs <ArrowUpRight className="h-4 w-4" />
            </a>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Hardware;
